document.addEventListener("DOMContentLoaded", function(event) {
  addAccordionEvents();
});

const addAccordionEvents = () => {
  const accordions = document.querySelectorAll('.c-accordion');
  accordions.forEach(accordion => {
    const accordionGrid = accordion.querySelector('.c-accordion__grid');
    if (accordionGrid) {
      accordion.querySelector('.c-accordion__nav-left').addEventListener('click', e => {
        accordionGrid.style.transform = "";
        e.currentTarget.classList.add('disabled');
        accordion.querySelector('.c-accordion__nav-right').classList.remove('disabled');
      });
  
      accordion.querySelector('.c-accordion__nav-right').addEventListener('click', e => {
        accordionGrid.style.transform = "translateX(-50%)";
        e.currentTarget.classList.add('disabled');
        accordion.querySelector('.c-accordion__nav-left').classList.remove('disabled');
      });
    }
  });

  const accordionItems = document.querySelectorAll('.c-accordion-item');
  accordionItems.forEach(accordionItem => {
    accordionItem.querySelector('.c-accordion-item__title').addEventListener('click', e => {
      const container = accordionItem.querySelector('.c-accordion-item__container');
      const icon = accordionItem.querySelector('.c-accordion-item__icon');
      window.addEventListener('resize', function(event){
        if (container.classList.contains('expanded')) {
          const maxHeight = container.scrollHeight;
          container.style.maxHeight = maxHeight + "px";
        }
      });
      if (container) {
        if (container.classList.contains('expanded')) {
          container.style.maxHeight = null;
          container.classList.remove('expanded');
          icon.classList.remove('expanded');
        } else {
          const maxHeight = container.scrollHeight;
          container.style.maxHeight = maxHeight + "px";
          container.classList.add('expanded');
          icon.classList.add('expanded');
        }
      }
    });
  });
}